export const createErrorMessage = async (
  endpoint: string,
  res: Response
): Promise<string> => {
  return `
    Title: API failed (${endpoint})
    Status: ${res.status}
    Status Text: ${res.statusText}
    Response Text: ${await res.text()}
  `;
};
